import React from 'react'
import SaveCard from '../../../payments/save-card'

const AddPaymentMethod = () => {
    return (
        <SaveCard />
    )
}

export default AddPaymentMethod